import React from "react";
import { useGlobalFilters } from "contexts/GlobalFiltersContext";
import { Spinner } from "components-lib";
import { Flex, Text } from "components-lib";
import { useColorModeValue } from "components-lib";
import StatsView from "views/admin/doctors/components/sections/StatsView";
import { token } from "stylis";
/**
 * GlobalFiltersBar
 * Sticky unified filters (clinic / doctor / date range) + slot for search & buttons.
 * Role-sensitive rendering.
 *
 * Place sibling controls (search, add patient) via children or by wrapping this bar above them.
 */


export default function GlobalFiltersBar({
    appointmentStats,
    appoinmentable,
    consultationsStats,
    consultable,
    rightContent = null,
    leftExtras = null,
    billsStats = null,
    showBills = false,
}) {
    const tokenpayload = JSON.parse(localStorage.getItem("user") || "{}");
    const { filters, lists, loading, actions } = useGlobalFilters();
    const { clinicId, doctorId, fromDate, toDate, roleContext } = filters;
    const { isAdmin, isOwner, isDoctor, isFrontdesk, userDoctorId } =
        roleContext;
    const { clinics, doctors } = lists;
    const { setClinicId, setDoctorId, setFromDate, setToDate } = actions;
    const menuBg = useColorModeValue("white", "navy.800");
    // If a user is both owner and doctor, they should not see clinic selector (they only operate in their clinic)
    const showClinic = (isAdmin || isOwner) && !(isOwner && isDoctor);
    // Show doctor selector for admin/owner/frontdesk. Also show it if user is a doctor (including owner-doctor)
    const showDoctor =
        isAdmin || isOwner || isFrontdesk || (isDoctor && isOwner);
    const showDate = true;
    const doctor = doctors.find(
        (d) => (d.id || d._id || d.doctor_id) === doctorId,
    );

    return (
        <>
            <div className="w-full  backdrop-blur   px-3 py-2 flex flex-wrap gap-3 items-center justify-between">
                <div className="flex items-center gap-3">
                    {/* Clinic Selector */}
                    {showClinic && (
                        <select
                            aria-label="Clinic"
                            className={`px-3 py-2 rounded-md ring-1  ring-gray-200 text-sm bg-white h-10 focus:outline-none focus:ring-1 focus:ring-indigo-200
              ${loading.clinics ? "opacity-60 cursor-not-allowed" : ""}`}
                            disabled={loading.clinics}
                            value={clinicId || ""}
                            onChange={(e) =>
                                setClinicId(e.target.value || null)
                            }
                        >
                            {loading.clinics ? (
                                <option>Loading clinics...</option>
                            ) : (
                                <>
                                    <option value="">
                                        {isAdmin
                                            ? "All Clinics"
                                            : "Select Clinic"}
                                    </option>
                                    {clinics.map((c) => {
                                        const id = c.id || c._id || c.clinic_id;
                                        return (
                                            <option key={id} value={id}>
                                                {c.name ||
                                                    c.clinic_name ||
                                                    `Clinic ${id}`}
                                            </option>
                                        );
                                    })}
                                </>
                            )}
                        </select>
                    )}

                    {/* Doctor Selector */}
                    {isDoctor ? (
                        <Text className="text-sm font-medium">
                            {/* {doctors.find(
                                (d) =>
                                    (d.id || d._id || d.doctor_id) ===
                                    userDoctorId,
                            )?.name ||
                                doctors.find(
                                    (d) =>
                                        (d.id || d._id || d.doctor_id) ===
                                        userDoctorId,
                                )?.doctor ||
                                "Myself"} */}
                            {/* {doctor?.doctor || doctor?.name || "Myself"} */}
                            {tokenpayload.doctor || tokenpayload.name || "Myself"}
                        </Text>
                    ) : (
                        showDoctor && (
                            <select
                                aria-label="Doctor"
                                className={`px-4 py-2 rounded-md ring-1  ring-gray-200 text-sm bg-white h-10 focus:outline-none focus:ring-1 focus:ring-indigo-200
              ${loading.doctors ? "opacity-60 cursor-not-allowed" : ""}`}
                                disabled={loading.doctors}
                                value={doctorId || ""}
                                onChange={(e) => setDoctorId(e.target.value || "")}
                            >
                                {loading.doctors ? (
                                    <option>Loading doctors...</option>
                                ) : (
                                    <>
                                        {!isDoctor && (
                                            <option value="">All Doctors</option>
                                        )}
                                        {doctors.map((d) => {
                                            const id = d.id || d._id || d.doctor_id;
                                            const label =
                                                d.doctor ||
                                                d.name ||
                                                d.full_name ||
                                                `Dr. ${d.doctor || d.name || id}`;
                                            return (
                                                <option key={id} value={id}>
                                                    {label}
                                                </option>
                                            );
                                        })}
                                        {isDoctor && !isOwner && userDoctorId && (
                                            <option value={userDoctorId}>
                                                Myself
                                            </option>
                                        )}
                                    </>
                                )}
                            </select>
                        )
                    )}



                    {/* Date Range Selector */}

                    {showDate && (
                        <div className="flex items-center gap-2 text-sm justify-between ">
                            <label className="sr-only" htmlFor="range-preset">
                                Range
                            </label>
                            <select
                                id="range-preset"
                                defaultValue="custom"
                                className="px-3 py-2 rounded-md  text-sm bg-white h-10 focus:outline-none ring-1  ring-gray-200 focus:ring-1 focus:ring-indigo-200"
                                onChange={(e) => {
                                    const preset = e.target.value;
                                    const today = new Date();
                                    const startOfWeek = (d) => {
                                        const dt = new Date(d);
                                        const day = dt.getDay();
                                        const diff =
                                            dt.getDate() -
                                            day +
                                            (day === 0 ? -6 : 1); // Monday start
                                        return new Date(dt.setDate(diff));
                                    };
                                    const startOfMonth = (d) =>
                                        new Date(
                                            d.getFullYear(),
                                            d.getMonth(),
                                            1,
                                        );
                                    const endOfMonth = (d) =>
                                        new Date(
                                            d.getFullYear(),
                                            d.getMonth() + 1,
                                            0,
                                        );
                                    const format = (d) => {
                                        if (!d) return "";
                                        const yyyy = d.getFullYear();
                                        const mm = String(
                                            d.getMonth() + 1,
                                        ).padStart(2, "0");
                                        const dd = String(d.getDate()).padStart(
                                            2,
                                            "0",
                                        );
                                        return `${yyyy}-${mm}-${dd}`;
                                    };

                                    let from = null;
                                    let to = null;
                                    switch (preset) {
                                        case "today":
                                            from = to = today;
                                            break;
                                        case "last_7":
                                            from = new Date(today);
                                            from.setDate(from.getDate() - 6);
                                            to = today;
                                            break;
                                        case "this_week":
                                            from = startOfWeek(new Date(today));
                                            to = today;
                                            break;
                                        case "this_month":
                                            from = startOfMonth(
                                                new Date(today),
                                            );
                                            to = endOfMonth(new Date(today));
                                            break;
                                        default:
                                            // custom - keep current values
                                            from = null;
                                            to = null;
                                    }

                                    setFromDate(from ? format(from) : "");
                                    setToDate(to ? format(to) : "");
                                }}
                            >
                                <option value="custom">Custom</option>
                                <option value="today">Today</option>
                                <option value="last_7">Last 7 days</option>
                                <option value="this_week">This week</option>
                                <option value="this_month">This month</option>
                            </select>

                            <label
                                className="font-medium sr-only"
                                htmlFor="from-date"
                            >
                                From
                            </label>
                            <input
                                id="from-date"
                                type="date"
                                className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm h-10 focus:outline-none ring-1  ring-gray-200 focus:ring-indigo-200"
                                value={fromDate || ""}
                                onChange={(e) =>
                                    setFromDate(e.target.value || "")
                                }
                            />

                            <label
                                className="font-medium sr-only"
                                htmlFor="to-date"
                            >
                                To
                            </label>
                            <input
                                id="to-date"
                                type="date"
                                className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm h-10 ring-1  ring-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-200"
                                value={toDate || ""}
                                onChange={(e) =>
                                    setToDate(e.target.value || "")
                                }
                            />
                        </div>
                    )}
                </div>
                {(loading.clinics || loading.doctors) && <Spinner size="sm" />}

                {/* Left extras slot */}
                {leftExtras}
                {/* Right aligned content: search, buttons etc */}
                {rightContent}
                {appoinmentable && (
                    <StatsView
                        total={appointmentStats.total || 0}
                        pending={appointmentStats.pending || 0}
                        completed={appointmentStats.completed || 0}
                        pageType="Appointments"
                    />
                )}
                {consultable && (
                    <StatsView
                        total={consultationsStats.totalAppointments || 0}
                        pending={consultationsStats.pendingAppointments || 0}
                        completed={
                            consultationsStats.completedAppointments || 0
                        }
                        pageType="Consultations"
                    />
                )}
                {showBills && billsStats && (
                    <StatsView
                        pageType="Bills"
                        billTotalRevenue={billsStats.totalRevenue || 0}
                        billPaid={billsStats.paidBills || 0}
                        billPending={billsStats.pendingBills || 0}
                        billBooked={billsStats.bookedBills || 0}
                    />
                )}
            </div>
        </>
    );
}
